/* Retire query-only Searchanise links without silently discarding old filters. */
(() => {
  const root=document.querySelector('[data-legacy-search]');if(!root)return;
  const input=root.querySelector('input[name="q"]'),message=root.querySelector('[data-legacy-search-message]');
  const form=root.querySelector('form');if(!input||!message||!form)return;
  let target,current;
  try {target=new URL(form.action,location.origin);current=new URL(location.href);} catch{return;}
  if(target.origin!==location.origin||target.username||target.password||!/^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?search$/i.test(target.pathname))return;
  target.search='';target.hash='';
  const neutral=new Set(['utm_source','utm_medium','utm_campaign','utm_term','utm_content','utm_id','gclid','fbclid','msclkid','preview_theme_id']);
  const values=current.searchParams.getAll('q');
  const query=values.length===1?values[0].trim():'';
  const readable=query.length<=1000&&!/[\u0000-\u001f\u007f\ufffd]/.test(query);
  if(readable)input.value=query;
  const validateLength=()=>input.setCustomValidity(input.value.length>150?'Shorten your search to 150 characters or fewer.':'');
  validateLength();input.addEventListener('input',validateLength);
  let supported=current.href.length<=8192&&!current.hash&&values.length===1&&readable&&query.length>0&&query.length<=150;
  for(const [key,value] of current.searchParams){
    if(key==='q')continue;
    if(!neutral.has(key)||current.searchParams.getAll(key).length!==1||value.length>256||/[\u0000-\u001f\u007f\ufffd]/.test(value)){supported=false;continue;}
    if(key==='preview_theme_id'&&!/^\d{1,20}$/.test(value)){supported=false;continue;}
    target.searchParams.set(key,value);
  }
  const preview=current.searchParams.getAll('preview_theme_id');
  if(preview.length===1&&/^\d{1,20}$/.test(preview[0])){const hidden=document.createElement('input');hidden.type='hidden';hidden.name='preview_theme_id';hidden.value=preview[0];form.append(hidden);}
  // Recognized vendor product-type filters become Product Line state on the native
  // route; unknown or ambiguous ones stay on this form instead of guessing a selection.
  const legacy=window.FHLegacyFilters?.recover?.(current,{surface:'legacy',basePath:target.pathname});
  if(legacy?.status==='mapped'){message.textContent='Opening your search…';location.replace(legacy.url.pathname+legacy.url.search);return;}
  if(legacy?.status==='unsupported'){
    // A vendor tag token is machine state; handing it back as a search term would look
    // like the shopper typed it. Real query text stays in the box.
    if(legacy.reason==='vendor_tag_query'){input.value='';validateLength();}
    message.textContent='We couldn’t carry the product filters in this older link over. Choose Search below to start again, then refine your results.';return;
  }
  if(!supported){
    if(current.search||current.hash)message.textContent='This older link has settings we couldn’t carry over. Choose Search below to start again, then refine your results.';
    return;
  }
  target.searchParams.set('q',query);target.searchParams.set('type','product');target.searchParams.set('options[unavailable_products]','hide');
  message.textContent='Opening your search…';
  // Replace the obsolete history entry, so Back does not bounce through it.
  location.replace(target.pathname+target.search);
})();
